import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 550px;
  margin: 0 auto;
  text-align: center;
`;

const Empty = ({ image, title, body }: any) => (
  <Wrap>
    <img src={image} style={{ width: 400, height: 211, alignSelf: 'center' }} alt="" />
    <Typography.Title level={3}>{title}</Typography.Title>
    <Typography.Paragraph>{body}</Typography.Paragraph>
  </Wrap>
);

export default Empty;
